/**
 * Fiscal year helpers for reporting-related dropdowns.
 *
 * Giganaut started in 2020, so fiscal year selectors always show the full
 * range from 2020 through to one year beyond the current calendar year.
 * For example, in calendar year 2026 the list is [2027, 2026, ..., 2020]
 * (most recent first). In 2027 it will automatically include 2028.
 *
 * The options are returned as { text, value } objects rather than raw
 * numbers because Vuetify's v-select in dense + hide-details mode does
 * not reliably render a selected primitive value inside the input — the
 * label stays as "Fiscal Year" even after a year is picked. Using the
 * default item-text / item-value keys avoids that rendering bug.
 */

export interface FiscalYearOption {
  text: string;
  value: number;
}

const GIGANAUT_START_FISCAL_YEAR = 2020;

/**
 * Returns fiscal years from GIGANAUT_START_FISCAL_YEAR through one year
 * beyond the current calendar year, sorted descending (most recent first).
 */
export function getFiscalYearOptions(): FiscalYearOption[] {
  const endYear = new Date().getFullYear() + 1;
  const options: FiscalYearOption[] = [];
  for (let year = endYear; year >= GIGANAUT_START_FISCAL_YEAR; year--) {
    options.push({ text: year.toString(), value: year });
  }
  return options;
}
